var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "hotel-directory-amenities amenities",
      class: { expanded: _vm.expanded },
    },
    [
      !_vm.expanded
        ? _vm._l(_vm.amenitiesData, function (amenity) {
            return _c(
              "span",
              {
                key: amenity.abbr,
                staticClass: "icon",
                class: { active: _vm.amenities.indexOf(amenity.abbr) >= 0 },
              },
              [
                _c("span", { staticClass: "label" }, [
                  _vm._v(" " + _vm._s(amenity.abbr)),
                ]),
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v(_vm._s(amenity.icon)),
                ]),
              ]
            )
          })
        : _vm._l(_vm.amenitiesData, function (amenity) {
            return _c(
              "div",
              {
                key: amenity.abbr,
                staticClass: "amenity",
                class: { active: _vm.amenities.indexOf(amenity.abbr) >= 0 },
              },
              [
                _c("i", { staticClass: "material-icons figure" }, [
                  _vm._v(_vm._s(amenity.icon)),
                ]),
                _c("span", { staticClass: "label" }, [
                  _vm._v(" " + _vm._s(amenity.name)),
                ]),
                _c("i", { staticClass: "material-icons check" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.amenities.indexOf(amenity.abbr) >= 0
                          ? "check_circle"
                          : "block"
                      ) +
                      " "
                  ),
                ]),
              ]
            )
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }